import { Button, Checkbox } from 'antd';
import React from 'react';
import { useDispatch } from 'react-redux';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import {
  decrementItem,
  incrementItem,
  reduceCartItemToZero,
} from '../../../Redux/slices/cartSlice';
import PropTypes from 'prop-types';

const Category = ({
  items,
  handleTicketCheckBox,
  checkedItems,
  setCheckedItems,
}) => {
  Category.propTypes = {
    items: PropTypes.object,
    handleTicketCheckBox: PropTypes.func,
    checkedItems: PropTypes.array,
    setCheckedItems: PropTypes.func,
  };

  const dispatch = useDispatch();
  const handleDecrement = (itemId) => {
    dispatch(decrementItem(itemId));
  };

  const handleIncrement = (itemId) => {
    dispatch(incrementItem(itemId));
  };
  return (
    <>
      {' '}
      {items?.tickets?.map((item, index) => (
        <div key={item.id} className="payment-booking-body">
          <div className="order-summary-container square-container border-radius-14">
            <span className="square-heading">Category</span>
            <div className="ticket-pricing-container">
              <div className="ticket-name-container">
                <Checkbox
                  className="ticket-selector"
                  onChange={() => {
                    if (
                      item.selectedQuantity == null ||
                      item.selectedQuantity === 0
                    ) {
                      handleIncrement(item.id);
                    }
                    handleTicketCheckBox(
                      checkedItems,
                      setCheckedItems,
                      item.id
                    );
                    if (checkedItems.includes(item.id)) {
                      dispatch(reduceCartItemToZero(item.id));
                    }
                  }}
                  checked={item.selectedQuantity > 0}
                />
                <span className="ticket-category-text"> {item.title}</span>
              </div>

              <div className="ticket-action-container">
                <Button
                  disabled={
                    !checkedItems.includes(item.id) ||
                    item.selectedQuantity === 1
                  }
                  onClick={() => handleDecrement(item.id)}
                  className="ticket-action-btn"
                >
                  <MinusOutlined
                    style={{
                      color:
                        !checkedItems.includes(item.id) ||
                        item.selectedQuantity >= item.quantity - item.sold ||
                        item.selectedQuantity === 6
                          ? '#dedede'
                          : '#CE202F',
                    }}
                  />
                </Button>
                <span className="cart-item-quantity">
                  {item.selectedQuantity ?? 0}
                </span>
                <Button
                  disabled={
                    !checkedItems.includes(item.id) ||
                    item.selectedQuantity >= item.quantity - item.sold ||
                    item.selectedQuantity === 6
                  }
                  onClick={() => {
                    handleIncrement(item.id);
                  }}
                  className="ticket-action-btn"
                >
                  <PlusOutlined
                    style={{
                      color:
                        !checkedItems.includes(item.id) ||
                        item.selectedQuantity >= item.quantity - item.sold ||
                        item.selectedQuantity === 6
                          ? '#dedede'
                          : '#CE202F',
                    }}
                  />
                </Button>
              </div>
            </div>
            <div className="ticket-extra-details">
              <span className="ticket-price-text"> ₹{item.price}</span>
              {/* <div className="ticket-details-container">
                  <h5 className="ticket-price-text">Details:</h5>
                </div> */}
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default Category;
